import React, { useState } from "react"
import { Image } from "react-bootstrap"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

import ExcelExport from './ExcelExport'

import "./Footer.scss"
import psmfcLogo from "../../images/psmfc-logo.svg"
import noaaLogo from "../../images/noaa-logo.png"

function Footer() {

    const [footer, displayFooter] = useState(true)
    const toggle = () => displayFooter(!footer)

  return (
    <>
    <div className={footer ? 'Footer' : 'Footer hidden'}>
        <div className="LeftFooter">
            <div className="Logotype">
                <Image src={noaaLogo} />
                <Image src={psmfcLogo} />
            </div>
            <div className="Message">
                This tool is a cooperative project between 
                PSMFC, NMFS' Alaska Regional Office, and 
                NMFS' Alaska Fisheries Science Center, with 
                funding provided by the NMFS Office of Science 
                and Technology.
                The 10MRSAM used in this web tool was constructed by Dr. Edward
                Waters with Cascade Economics, LLC.
            </div>
        </div>

        <div className="RightFooter">
            <ExcelExport 
                id=""
                className="ExportButton"
                table="Output_hidden"
                filename="Report"
                sheet="Page1"
                buttonText="Export to Excel" />

            <div className="HideFooter"><h4 onClick={toggle}>Hide</h4></div>
        </div>
    </div>
    <div className={footer ? 'ShowFooterButton hidden' : 'ShowFooterButton'} onClick={toggle}>
        <FontAwesomeIcon icon={faChevronLeft}/>
    </div>
    </>
  )
}

export default Footer